import { Component, ElementRef, OnInit } from '@angular/core';
import { Log, Path } from '@s8l/client-tree-lib';

import { AggregationGroup } from 'src/app/services/jsonrpc/stats-server.service';
import { MetricAttrMap, StatsService } from 'src/app/services/stats.service';

import { HomeWidget } from '../dashboard-widget.utils';

@Component({
  selector: 'app-table-widget',
  templateUrl: './table-widget.component.html',
  styleUrls: ['./table-widget.component.scss']
})
export class TableWidgetComponent extends HomeWidget implements OnInit {
  public groupBy: AggregationGroup[] = [];
  public datasets: AggregationGroup[] = [];

  public values: any = null;
  public rowHeaders: string[] = [];
  public columnHeaders: string[] = [];
  public error = false;

  constructor(elRef: ElementRef, protected stats: StatsService) {
    super(elRef);
  }

  public ngOnInit(): Promise<any> {
    if (this.settings.grouping) {
      if (Array.isArray(this.settings.grouping)) {
        this.groupBy = this.settings.grouping;
      } else {
        this.groupBy.push(this.settings.grouping);
      }
    } else {
      // this.groupBy.push(AggregationGroup.type);
    }

    if (this.settings.datasets) {
      if (Array.isArray(this.settings.datasets)) {
        this.datasets = this.settings.datasets;
      } else {
        this.datasets.push(this.settings.datasets);
      }
    }

    return this.loadData()
      .then(data => this.initData(data))
      .then(() => (this.error = false))
      .catch(err => {
        this.error = true;
        this.values = null;
        Log.log('TableWidgetComponent', 'Error', err);
      });
  }

  // Multi Table overwrites this!
  public loadData(): Promise<any> {
    return this.stats
      .fetchMetrics(
        this.settings.metric,
        this.settings.relative,
        [...this.groupBy, ...this.datasets],
        this.settings.filter,
        this.settings.exclude,
        this.settings.from,
        this.settings.to
      )
      .then(data => this.stats.filterNullColumn(data, this.settings.grouping))
      .then(result =>
        this.stats.processMetrics(
          result,
          this.settings.relative ? 'relative' : MetricAttrMap[this.settings.metric],
          this.groupBy,
          this.datasets,
          this.settings.labelNames
        )
      );
  }

  private initData(data): void {
    const totalLabel = 'Total';

    if (data.rows.length > 1 && this.settings.totalRow) {
      for (const col of data.columns) {
        let value = 0;
        for (const row of data.rows) {
          value += data.values[col][row] || 0;
        }
        data.values[col][totalLabel] = value;
      }
      data.rows.push(totalLabel);
    }

    if (data.columns.length > 1 && this.settings.totalColumn) {
      data.values[totalLabel] = [];
      for (const row of data.rows) {
        let value = 0;
        for (const col of data.columns) {
          value += data.values[col][row] || 0;
        }
        data.values[totalLabel][row] = value;
      }
      data.columns.push(totalLabel);
    }

    this.values = data.values;
    this.rowHeaders = data.rows;
    this.columnHeaders = data.columns;
  }
}
